var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0305 10.5993L15.7415 6.88835C15.9176 6.71254 16.0167 6.47396 16.0169 6.22511C16.0171 5.97626 15.9185 5.73751 15.7426 5.56139C15.5668 5.38527 15.3283 5.2862 15.0794 5.28599C14.8306 5.28577 14.5918 5.38441 14.4157 5.56022L10.7048 9.27116L6.99381 5.56022C6.81769 5.3841 6.57882 5.28516 6.32975 5.28516C6.08068 5.28516 5.84181 5.3841 5.66569 5.56022C5.48957 5.73634 5.39062 5.97521 5.39062 6.22428C5.39062 6.47335 5.48957 6.71222 5.66569 6.88835L9.37663 10.5993L5.66569 14.3102C5.48957 14.4863 5.39062 14.7252 5.39062 14.9743C5.39062 15.2234 5.48957 15.4622 5.66569 15.6383C5.84181 15.8145 6.08068 15.9134 6.32975 15.9134C6.57882 15.9134 6.81769 15.8145 6.99381 15.6383L10.7048 11.9274L14.4157 15.6383C14.5918 15.8145 14.8307 15.9134 15.0798 15.9134C15.3288 15.9134 15.5677 15.8145 15.7438 15.6383C15.9199 15.4622 16.0189 15.2234 16.0189 14.9743C16.0189 14.7252 15.9199 14.4863 15.7438 14.3102L12.0305 10.5993Z",
    fill: "#FB2047"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.b7f4068427e9d04a3c5f3641bac80ec3.svg";
export { ForwardRef as ReactComponent };